import {
  CardActionArea as MuiCardActionArea,
  CardMedia as MuiCardMedia,
  Grid as MuiGrid,
  Stack as MuiStack,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatItem } from "@framework/exchange";
import type { IMerge } from "@framework/types";
import { Card, Typography } from "@dzambalaorg/ui-kit";

import { MergeButton } from "../../../../../../../components/buttons";
import { MergeIngredients } from "./menu";

interface IMergeItemProps {
  merge: IMerge;
}

export const MergeItem = (props: IMergeItemProps) => {
  const { merge } = props;
  return (
    <MuiCardActionArea component={RouterLink} to={`/recipes/merge/${merge.id}/view`}>
      <Card>
        <Card.Header
          action={<MergeIngredients merge={merge} />}
          title={<MuiCardMedia image={merge.item?.components[0].template!.imageUrl} />}
          subheader={
            <MuiStack>
              <Typography variant="h5" color="textPrimary">
                {formatItem(merge.item)}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {formatItem(merge.price)}
              </Typography>
            </MuiStack>
          }
        />

        <Card.Footer>
          <MuiGrid container alignItems="center">
            <MergeButton merge={merge} />
          </MuiGrid>
        </Card.Footer>
      </Card>
    </MuiCardActionArea>
  );
};
